<h1 mat-dialog-title>{{'components.createProgramIncrementDialog.titleCreateProgramIncrement' | translate}}</h1>
<div mat-dialog-content>
  <p>{{'components.createProgramIncrementDialog.name' | translate}}</p>
  <mat-form-field class='piFormInput'>
    <input matInput required [(ngModel)]="data.name">
  </mat-form-field>
  <p>{{'components.createProgramIncrementDialog.goal' | translate}}</p>
  <mat-form-field class='piFormInput'>
    <input matInput required [(ngModel)]="data.goal">
  </mat-form-field>
  <p>{{'components.createProgramIncrementDialog.start' | translate}}</p>
  <mat-form-field class='piFormInput'>
    <input matInput required [matDatepicker]="pickerStart" [min]="data.minDate" [(ngModel)]="data.start">
    <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
    <mat-datepicker #pickerStart></mat-datepicker>
  </mat-form-field>
  <p>{{'components.createProgramIncrementDialog.numberOfSprints' | translate}}</p>
  <mat-form-field class='piFormInput'>
    <input type='number' required min='1' class='piFormInput' matInput [(ngModel)]="data.numberOfSprints">
  </mat-form-field>
  <p>{{'components.createProgramIncrementDialog.sprintDuration' | translate}}</p>
  <mat-form-field class='piFormInput'>
    <input type='number' required min='1' matInput [(ngModel)]="data.sprintDuration">
  </mat-form-field>
  <p>{{'components.createProgramIncrementDialog.sprintPrefix' | translate}}</p>
  <p>{{'components.createProgramIncrementDialog.sprintNamePreview' | translate}}"{{data.sprintPrefix}} 1"</p>
  <mat-form-field class='piFormInput'>
    <input type='text' name='sprintPrefix' matInput [(ngModel)]="data.sprintPrefix">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button
    [disabled]="!data.name || !data.goal || !data.start || !data.numberOfSprints || !data.sprintDuration"
    [mat-dialog-close]="data">{{'components.createProgramIncrementDialog.create' | translate}}</button>
  <button mat-button (click)="cancel()">{{'components.createProgramIncrementDialog.cancel' | translate}}</button>
</div>